import { v4 as uuid } from "uuid";
import isUUID from "validator/lib/isUUID";
import assert from "./Assert";

export class UUID  {
  constructor(readonly value: string) {
    assert(UUID.validate(value));
  }

  static generate(): UUID {
    const id = uuid();
    return new UUID(id);
  }

  static validate(id: string): boolean {
    try {
      return isUUID(id, 4);
    } catch (error) {
      return false;
    }
  }

  matches(uuid: UUID): boolean {
    return this.value === uuid.value;
  }
}
